import { Link, useLocation } from "react-router-dom";
import { useSEO } from "@/lib/seo";

export default function NotFound() {
  const { pathname } = useLocation();
  useSEO({ title: "Page Not Found — Mashara Finance", description: "The page you requested does not exist.", path: pathname, noindex: true });

  return (
    <div className="py-32 text-center" data-testid="not-found-page">
      <p className="text-xs font-semibold uppercase tracking-widest text-emerald-700 mb-3">404</p>
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900">Page not found</h1>
      <p className="mt-3 text-slate-600">The page you're looking for doesn't exist or has moved.</p>
      <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm font-semibold text-emerald-700">
        <Link to="/" data-testid="not-found-home-link">Go home →</Link>
        <Link to="/pricing">Pricing</Link>
        <Link to="/blog">Resources</Link>
        <Link to="/demo">Book a Demo</Link>
      </div>
    </div>
  );
}
